window.theme = window.theme || {};
let SideCart;
(function(){
    'use strict';

    theme.delegate = {
      on: function(event, callback, options){
        if( !this.namespaces ) // save the namespaces on the DOM element itself
          this.namespaces = {};

        this.namespaces[event] = callback;
        options = options || false;

        this.addEventListener(event.split('.')[0], callback, options);
        return this;
      },
      off: function(event) {
        if (!this.namespaces) { return }
        this.removeEventListener(event.split('.')[0], this.namespaces[event]);
        delete this.namespaces[event];
        return this;
      }
    };

    // Extend the DOM with these above custom methods
    window.on = Element.prototype.on = theme.delegate.on;
    window.off = Element.prototype.off = theme.delegate.off;

    theme.Currency = (function() {
        var moneyFormat = '${{amount}}';
        var superScript = theme && theme.settings && theme.settings.superScriptPrice;

        function formatMoney(cents, format) {
          if (!format) {
            format = theme.settings.moneyFormat;
          }

          if (typeof cents === 'string') {
            cents = cents.replace('.', '');
          }
          var value = '';
          var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
          var formatString = (format || moneyFormat);

          function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = theme.utils.defaultTo(precision, 2);
            thousands = theme.utils.defaultTo(thousands, ',');
            decimal = theme.utils.defaultTo(decimal, '.');

            if (isNaN(number) || number == null) {
              return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
            var centsAmount = parts[1] ? (decimal + parts[1]) : '';

            return dollarsAmount + centsAmount;
          }

          switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
              value = formatWithDelimiters(cents, 2);

              if (superScript && value && value.includes('.')) {
                value = value.replace('.', '<sup>') + '</sup>';
              }

              break;
            case 'amount_no_decimals':
              value = formatWithDelimiters(cents, 0);
              break;
            case 'amount_with_comma_separator':
              value = formatWithDelimiters(cents, 2, '.', ',');

              if (superScript && value && value.includes(',')) {
                value = value.replace(',', '<sup>') + '</sup>';
              }

              break;
            case 'amount_no_decimals_with_comma_separator':
              value = formatWithDelimiters(cents, 0, '.', ',');
              break;
            case 'amount_no_decimals_with_space_separator':
              value = formatWithDelimiters(cents, 0, ' ');
              break;
          }

          return formatString.replace(placeholderRegex, value);
        }

        function getBaseUnit(variant) {
          if (!variant) {
            return;
          }

          if (!variant.unit_price_measurement || !variant.unit_price_measurement.reference_value) {
            return;
          }

          return variant.unit_price_measurement.reference_value === 1
            ? variant.unit_price_measurement.reference_unit
            : variant.unit_price_measurement.reference_value +
                variant.unit_price_measurement.reference_unit;
        }

        return {
          formatMoney: formatMoney,
          getBaseUnit: getBaseUnit
        }
    })();

    theme.utils = {
        defaultTo: function(value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value
        },

        wrap: function(el, wrapper) {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
        },

        debounce: function(wait, callback, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
            timeout = null;
            if (!immediate) callback.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) callback.apply(context, args);
        }
        },

        throttle: function(limit, callback) {
        var waiting = false;
        return function () {
            if (!waiting) {
            callback.apply(this, arguments);
            waiting = true;
            setTimeout(function () {
                waiting = false;
            }, limit);
            }
        }
        },

        prepareTransition: function(el, callback) {
        el.addEventListener('transitionend', removeClass);

        function removeClass(evt) {
            el.classList.remove('is-transitioning');
            el.removeEventListener('transitionend', removeClass);
        }

        el.classList.add('is-transitioning');
        el.offsetWidth; // check offsetWidth to force the style rendering

        if (typeof callback === 'function') {
            callback();
        }
        },

        // _.compact from lodash
        // Creates an array with all falsey values removed. The values `false`, `null`,
        // `0`, `""`, `undefined`, and `NaN` are falsey.
        // _.compact([0, 1, false, 2, '', 3]);
        // => [1, 2, 3]
        compact: function(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
            var value = array[index];
            if (value) {
            result[resIndex++] = value;
            }
        }
        return result;
        },

        serialize: function(form) {
        var arr = [];
        Array.prototype.slice.call(form.elements).forEach(function(field) {
            if (
            !field.name ||
            field.disabled ||
            ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
            )
            return;
            if (field.type === 'select-multiple') {
            Array.prototype.slice.call(field.options).forEach(function(option) {
                if (!option.selected) return;
                arr.push(
                encodeURIComponent(field.name) +
                    '=' +
                    encodeURIComponent(option.value)
                );
            });
            return;
            }
            if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
            return;
            arr.push(
            encodeURIComponent(field.name) + '=' + encodeURIComponent(field.value)
            );
        });
        return arr.join('&');
        }
    };

    theme.a11y = {
        trapFocus: function(options) {
          var eventsName = {
            focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
            focusout: options.namespace
              ? 'focusout.' + options.namespace
              : 'focusout',
            keydown: options.namespace
              ? 'keydown.' + options.namespace
              : 'keydown.handleFocus'
          };

          // Get every possible visible focusable element
          var focusableEls = options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])');
          var elArray = [].slice.call(focusableEls);
          var focusableElements = elArray.filter(el => el.offsetParent !== null);

          var firstFocusable = focusableElements[0];
          var lastFocusable = focusableElements[focusableElements.length - 1];

          if (!options.elementToFocus) {
            options.elementToFocus = options.container;
          }

          options.container.setAttribute('tabindex', '-1');
          options.elementToFocus.focus();

          document.documentElement.off('focusin');
          document.documentElement.on(eventsName.focusout, function() {
            document.documentElement.off(eventsName.keydown);
          });

          document.documentElement.on(eventsName.focusin, function(evt) {
            if (evt.target !== options.container && evt.target !== lastFocusable && evt.target !== firstFocusable) return;

            document.documentElement.on(eventsName.keydown, function(evt) {
              _manageFocus(evt);
            });
          });

          function _manageFocus(evt) {
            if (evt.keyCode !== 9) return;
            /**
             * On the first focusable element and tab backward,
             * focus the last element
             */
            if (evt.target === lastFocusable && !evt.shiftKey) {
              evt.preventDefault();
              firstFocusable.focus();
            }
          }
        },
        removeTrapFocus: function(options) {
          var eventName = options.namespace
            ? 'focusin.' + options.namespace
            : 'focusin';

          if (options.container) {
            options.container.removeAttribute('tabindex');
          }

          document.documentElement.off(eventName);
        },

        lockMobileScrolling: function(namespace, element) {
          var el = element ? element : document.documentElement;
          document.documentElement.classList.add('lock-scroll');
          el.on('touchmove' + namespace, function() {
            return true;
          });
        },

        unlockMobileScrolling: function(namespace, element) {
          document.documentElement.classList.remove('lock-scroll');
          var el = element ? element : document.documentElement;
          el.off('touchmove' + namespace);
        }
    };

    theme.Drawers = (function() {
        function Drawers(id, name) {
        this.config = {
            id: id,
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + name,
            openClass: 'js-drawer-open',
            closingClass: 'js-drawer-closing',
            activeDrawer: 'drawer--is-open',
            namespace: '.drawer-' + name
        };

        this.nodes = {
            page: document.querySelector('#MainContent')
        };

        this.drawer = document.querySelector('#' + id);
        this.isOpen = false;

        if (!this.drawer) {
            return;
        }

        this.init();
        }

        Drawers.prototype = Object.assign({}, Drawers.prototype, {
        init: function() {
            // Setup open button(s)
            document.querySelectorAll(this.config.open).forEach(openBtn => {
            openBtn.setAttribute('aria-expanded', 'false');
            openBtn.addEventListener('click', this.open.bind(this));
            });

            this.drawer.querySelector(this.config.close).addEventListener('click', this.close.bind(this));

            // Close modal if a drawer is opened
            document.addEventListener('modalOpen', function() {
            this.close();
            }.bind(this));
        },

        open: function(evt, returnFocusEl) {
            if (evt) {
            evt.preventDefault();
            }

            if (this.isOpen) {
            return;
            }

            // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
            if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            // save the source of the click, we'll focus to this on close
            evt.currentTarget.setAttribute('aria-expanded', 'true');
            this.activeSource = evt.currentTarget;
            } else if (returnFocusEl) {
            returnFocusEl.setAttribute('aria-expanded', 'true');
            this.activeSource = returnFocusEl;
            }

            theme.utils.prepareTransition(this.drawer, function() {
            this.drawer.classList.add(this.config.activeDrawer);
            }.bind(this));

            document.documentElement.classList.add(this.config.openClass);
            this.isOpen = true;

            theme.a11y.trapFocus({
            container: this.drawer,
            namespace: 'drawer_focus'
            });
            theme.cart.Cart();
            document.dispatchEvent(new CustomEvent('drawerOpen'));
            document.dispatchEvent(new CustomEvent('drawerOpen.' + this.config.id));

            this.bindEvents();

            $('html,body').removeClass("lock-scroll");
            $('html,body').removeClass("js-drawer-open-nav-open");
        },

        close: function(evt) {
            if (!this.isOpen) {
            return;
            }

            // Do not close if click event came from inside drawer
            if (evt) {
            if (evt.target.closest('.js-drawer-close')) {
                // Do not close if using the drawer close button
            } else if (evt.target.closest('.drawer')) {
                return;
            }
            }
            // deselect any focused form elements
            document.activeElement.blur();

            theme.utils.prepareTransition(this.drawer, function() {
            this.drawer.classList.remove(this.config.activeDrawer);
            }.bind(this));

            document.documentElement.classList.remove(this.config.openClass);
            document.documentElement.classList.add(this.config.closingClass);

            window.setTimeout(function() {
            document.documentElement.classList.remove(this.config.closingClass);
            if (this.activeSource && this.activeSource.getAttribute('aria-expanded')) {
                this.activeSource.setAttribute('aria-expanded', 'false');
                this.activeSource.focus();
            }
            }.bind(this), 500);

            this.isOpen = false;

            theme.a11y.removeTrapFocus({
            container: this.drawer,
            namespace: 'drawer_focus'
            });

            this.unbindEvents();
        },

        bindEvents: function() {
            // Clicking out of drawer closes it
            window.on('click' + this.config.namespace, function(evt) {
            this.close(evt)
            return;
            }.bind(this));

            // Pressing escape closes drawer
            window.on('keyup' + this.config.namespace, function(evt) {
            if (evt.keyCode === 27) {
                this.close();
            }
            }.bind(this));

            theme.a11y.lockMobileScrolling(this.config.namespace, this.nodes.page);
        },

        unbindEvents: function() {
            window.off('click' + this.config.namespace);
            window.off('keyup' + this.config.namespace);

            theme.a11y.unlockMobileScrolling(this.config.namespace, this.nodes.page);
        }
        });

        return Drawers;
    })();

    theme.CartDrawer = (function() {
        var selectors = {
        drawer: '#CartDrawer',
        form: '#CartDrawerForm'
        };

        function CartDrawer() {
        this.form = document.querySelector(selectors.form);
        this.drawer = new theme.Drawers('CartDrawer', 'cart');

        this.init();
        }

        CartDrawer.prototype = Object.assign({}, CartDrawer.prototype, {
        init: function() {
            this.cartForm = new theme.CartForm(this.form);
            this.cartForm.buildCart();

            document.addEventListener('ajaxProduct:added', function(evt) {
            this.cartForm.buildCart();
            this.open();
            }.bind(this));

            // Dev-friendly way to open cart
            document.addEventListener('cart:open', this.open.bind(this));
            document.addEventListener('cart:close', this.close.bind(this));
        },
        open: function() {
            this.drawer.open();
            theme.cart.Cart();
            theme.a11y.trapFocus({
            container: this.form,
            elementToFocus: this.form,
            namespace: 'cartdrawer_focus'
            });
        },

        close: function() {
            this.drawer.close();
            theme.cart.Cart();
            theme.a11y.removeTrapFocus({
            container: this.form,
            namespace: 'cartdrawer_focus'
            });
        }
        });

        return CartDrawer;
    })();

    theme.cart = {
        Cart: function(){
          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => { SideCart = cart;
            let cart_summary_shipping = document.querySelector('.cart-summary-shipping-price');
            let threshold = freeShippingThreshold;
            if(typeof freightFreeShippingThreshold !== "undefined"){
              if (document.body.classList.contains("shipscout-variant-B")) {
                threshold = freightFreeShippingThreshold;
              }
            }
            if(cart_summary_shipping) {
              var currentValue = cart.total_price / 100;
              var maxValue = threshold / 100;
              if (window.ConvertCurrency) {
                maxValue = parseFloat(window.ConvertCurrency(maxValue, 'USD', localStorage.getItem("iso_code")));
              }
              var hasSubscription = Array.isArray(cart.items) && cart.items.some(function(item) {
                return item.selling_plan_allocation;
              });
              var disableSubscriptionFreeShipping = window.disableSubscriptionFreeShipping === true
                || cart_summary_shipping.getAttribute('data-disable-subscription-free-shipping') === 'true';
              var marketOnly = window.freeShippingMarketOnly === true
                || cart_summary_shipping.getAttribute('data-free-shipping-market-only') === 'true';
              var marketConfigured = window.marketFreeShippingEnabled === true
                || cart_summary_shipping.getAttribute('data-market-free-shipping') === 'true';
              var meetsThreshold = marketConfigured && currentValue >= maxValue;
              var subscriptionEligible = hasSubscription && !disableSubscriptionFreeShipping;
              if (marketOnly && !marketConfigured) {
                subscriptionEligible = false;
              }
              var eligible = meetsThreshold || subscriptionEligible;
              cart_summary_shipping.classList.toggle('hidden', !eligible);
            }
          })
          .catch(error => console.error(error));
        },
        getCart: function() {
          var url = ''.concat(theme.routes.cart, '?t=').concat(Date.now());
          return fetch(url, {
            credentials: 'same-origin',
            method: 'GET'
          }).then(response => response.json());
        },

        addProduct: async function(dataProduct) {
          return await this._addCart({
            url: ''.concat(theme.routes.cartAdd, '?t=').concat(Date.now()),
            data: JSON.stringify(dataProduct)
          })
        },

        getCartProductMarkup: function() {
          var url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());

          url = url.indexOf('?') === -1 ? (url + '?view=ajax') : (url + '&view=ajax');

          return fetch(url, {
            credentials: 'same-origin',
            method: 'GET'
          })
          .then(response => response.text())
          .catch(e => console.error(e));
        },

        changeItem: function(key, qty) {

          return this._updateCart({
            url: ''.concat(theme.routes.cartChange, '?t=').concat(Date.now()),
            data: JSON.stringify({
              id: key,
              quantity: qty
            })
          })
        },

        _addCart: function(params) {
          return fetch(params.url, {
            method: 'POST',
            body: params.data,
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            }
          })
          .then(response => response.json())
          .then(cart => cart);
        },

        _updateCart: function(params) {
          let checkoutButton = document.querySelector('.btn.cart__checkout');
          if (checkoutButton) {
            checkoutButton.disabled = true;
          }
          return fetch(params.url, {
            method: 'POST',
            body: params.data,
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            }
          })
          .then(response => {
            return response.text()
          })
          .then(cart => {
            handleGwp();
            setTimeout(() => {
              const btn = document.querySelector('.btn.cart__checkout');
              if (btn) {
                btn.disabled = false;
              }
            }, 700);
            theme.cart.Cart();

            return cart;
          })
          .catch(error => {
            const btn = document.querySelector('.btn.cart__checkout');
            if (btn) {
              btn.disabled = false;
            }
            console.error('Error:', error);
          });
        },

        updateAttribute: function(key, value) {
          return this._updateCart({
            url: '/cart/update.js',
            data: JSON.stringify({
              attributes: {
                [key]: theme.cart.attributeToString(value)
              }
            })
          });
        },

        updateProduct: async function(key, value) {
          var cartForm = new theme.CartForm(document.querySelector('#CartDrawerForm'))
          let checkoutButton = document.querySelector('.btn.cart__checkout');

          if (checkoutButton) {
            checkoutButton.disabled = true;
          }

          let updates = {
            [key]: value
          };
          return await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
          })
          .then(response => {
            return response.json();
          })
          .then(data => {
            cartForm.buildCart();
            const btn = document.querySelector('.btn.cart__checkout');
            if (btn && data && data.item_count > 0) {
              btn.disabled = false;
            }
          })
          .catch((error) => {
            const btn = document.querySelector('.btn.cart__checkout');
            if (btn) {
              btn.disabled = false;
            }
            console.error('Error:', error);
          });
        },

        clearCart: async function(formData) {
          await fetch(window.Shopify.routes.root + 'cart/clear.js', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
              },
          })
          .then(response => response.json())
          .then(data => data)
          .catch((error) => {
              console.error('Error:', error);
          });
        },

        updateNote: function(note) {
          return this._updateCart({
            url: '/cart/update.js',
            data: JSON.stringify({
              note: theme.cart.attributeToString(note)
            })
          });
        },

        applyDiscount: function(code) {
          return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              discount: theme.cart.attributeToString(code)
            })
          }).then(function(response) {
            return response.json();
          });
        },

        removeDiscount: function() {
          return fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              discount: ''
            })
          }).then(function(response) {
            return response.json();
          });
        },

        getCartJson: function() {
          return fetch(window.Shopify.routes.root + 'cart.js', {
            credentials: 'same-origin',
            method: 'GET',
            headers: {
              'Accept': 'application/json'
            }
          }).then(function(response) {
            return response.json();
          });
        },

        attributeToString: function(attribute) {
          if ((typeof attribute) !== 'string') {
            attribute += '';
            if (attribute === 'undefined') {
              attribute = '';
            }
          }
          return attribute.trim();
        }
    };

    theme.CartForm = (function() {
        var selectors = {
        products: '[data-products]',
        progressBar: '[js-progress-bar]',
        progressBarAlt: '[js-progress-bar-alt]',
        gamification: '[js-gamification-bar]',
        gamificationAlt: '[js-gamification-bar-alt]',
        cartEmptyUpsell: '[js-cart-empty-drawer-upsell]',
        cartNonEmptyUpsell: '[js-cart-non-empty-drawer-upsell]',
        qtySelector: '.js-qty__wrapper',
        removeSelector: '.js-cart-remove',
        purchaseSelect: '.js-purchase-select',
        upgradeBtn: '.js-upgrade-btn',
        discounts: '[data-discounts]',
        gifts: '[data-gifts]',
        savings: '[data-savings]',
        subTotal: '[data-subtotal]',

        cartBubble: '.cart-link__bubble',
        checkoutBtn: '.cart__checkout',
        discountForm: '[data-cart-discount-form]',
        discountInput: '[data-discount-input]',
        discountApply: '[data-discount-apply]',
        discountMessage: '[data-discount-message]',
        discountToggle: '[data-discount-toggle]',
        discountExpand: '[data-discount-expand]',
        originalSubtotalWrap: '[data-original-subtotal-wrap]',
        originalSubtotal: '[data-original-subtotal]'
        };

        var classes = {
        btnLoading: 'btn--loading'
        };

        var config = {
        requiresTerms: false
        };

        function CartForm(form) {
        if (!form) {
            return;
        }

        this.form = form;
        this.wrapper = form.parentNode;
        this.location = form.dataset.location;
        this.namespace = '.cart-' + this.location;
        this.products = form.querySelector(selectors.products);
        this.progressBar = form.querySelector(selectors.progressBar);
        this.progressBarAlt = form.querySelector(selectors.progressBarAlt);
        this.gamification = form.querySelector(selectors.gamification);
        this.gamificationAlt = form.querySelector(selectors.gamificationAlt);
        this.cartEmptyUpsell = form.querySelector(selectors.cartEmptyUpsell);
        this.cartNonEmptyUpsell = form.querySelector(selectors.cartNonEmptyUpsell);
        this.submitBtn = form.querySelector(selectors.checkoutBtn);

        this.discounts = form.querySelector(selectors.discounts);
        this.gifts = form.querySelector(selectors.gifts);
        this.savings = form.querySelector(selectors.savings);
        this.subtotal = form.querySelector(selectors.subTotal);
        this.termsCheckbox = form.querySelector(selectors.termsCheckbox);
        this.noteInput = form.querySelector(selectors.cartNote);

        this.cartItemsUpdated = false;

        if (this.termsCheckbox) {
            config.requiresTerms = true;
        }

        this.openCartNote = form.querySelector('.btn.open-cartnote');
        this.openDiscount = form.querySelector('.btn.open-discount');
        this.discountForm = form.querySelector(selectors.discountForm);

        if(this.openCartNote) {
          this.openCartNote.addEventListener('click', (e) => {
            e.preventDefault();
            this.cntCartNote = form.querySelector('.cart__drawer-cartnote');
            this.cntCartNote.classList.toggle('show');
          })
        }

        if(this.openDiscount) {
          this.openDiscount.addEventListener('click', (e) => {
            e.preventDefault();
            this.cntDiscount = form.querySelector('.scDiscount__container');
            this.cntDiscount.classList.toggle('show');
          })
        }

        this.init();
        }

        CartForm.prototype = Object.assign({}, CartForm.prototype, {
        init: function() {
            this.initQtySelectors();
            this.initRemoveSelectors();
            this.initUpdatePurchase();
            this.initPurchaseSelectors();
            this.initDiscountForm();

            document.addEventListener('cart:quantity' + this.namespace, this.quantityChanged.bind(this));

            this.form.on('submit' + this.namespace, this.onSubmit.bind(this));

            if (this.noteInput) {
            this.noteInput.addEventListener('change', function() {
                var newNote = this.value;
                theme.cart.updateNote(newNote);
            });
            }

            // Dev-friendly way to build the cart
            document.addEventListener('cart:build', function() {
            this.buildCart();
            }.bind(this));
        },

        reInit: function() {
            this.initQtySelectors();
            this.initRemoveSelectors();
            this.initUpdatePurchase();
            this.initPurchaseSelectors();
        },

        onSubmit: function(evt) {
            this.submitBtn.classList.add(classes.btnLoading);

            /*
            Checks for drawer or cart open class on body element
            and then stops the form from being submitted. We are also
            checking against a custom property, this.cartItemsUpdated = false.

            Error is handled in the quantityChanged method

            For Expanse/Fetch/Gem quick add, if an error is present it is alerted
            through the add to cart fetch request in quick-add.js.

            Custom property this.cartItemsUpdated = false is reset in cart-drawer.js for
            Expanse/Fetch/Gem when using quick add
            */

            if (document.documentElement.classList.contains('js-drawer-open') && this.cartItemsUpdated ||
            document.documentElement.classList.contains('cart-open') && this.cartItemsUpdated) {
            this.submitBtn.classList.remove(classes.btnLoading);
            evt.preventDefault();
            return false;
            }

            if (config.requiresTerms) {
            if (this.termsCheckbox.checked) {
                // continue to checkout
            } else {
                alert(theme.strings.cartTermsConfirmation);
                this.submitBtn.classList.remove(classes.btnLoading)
                evt.preventDefault();
                return false;
            }
            }
        },

        /*============================================================================
            Query cart page to get markup
        ==============================================================================*/
        _parseProductHTML: function(text) {
            const html = document.createElement('div');
            html.innerHTML = text;

            setTimeout(() => {
              window.updateRTEBasedOnCondition();
            }, 200)

            return {
                gifts: html.querySelector('[data-gifts]'),
                items: html.querySelector('.cart__items'),
                discounts: html.querySelector('.cart__discounts'),
                progressBar: html.querySelector("[js-progress-bar]"),
                progressBarAlt: html.querySelector("[js-progress-bar-alt]"),
                gamification: html.querySelector("[js-gamification-bar]"),
                gamificationAlt: html.querySelector("[js-gamification-bar-alt]"),
                cartEmptyUpsell: html.querySelector("[js-cart-empty-drawer-upsell]"),
                cartNonEmptyUpsell: html.querySelector("[js-cart-non-empty-drawer-upsell]"),
            }
        },

        buildCart: function() {
          theme.cart.getCartProductMarkup().then(this.cartMarkup.bind(this));
        },

        cartMarkup: function(text) {
            var markup = this._parseProductHTML(text);

            var items = markup.items;
            var progressBar = markup.progressBar;
            var progressBarAlt = markup.progressBarAlt;
            var gifts = markup.gifts;
            var gamification = markup.gamification;
            var gamificationAlt = markup.gamificationAlt;
            var cartEmptyUpsell = markup.cartEmptyUpsell;
            var cartNonEmptyUpsell = markup.cartNonEmptyUpsell;
            var count = parseInt(items.dataset.count);
            var subtotal = items.dataset.cartSubtotal;
            var originalSubtotal = items.dataset.cartOriginalSubtotal;
            var totalDiscount = parseInt(items.dataset.cartTotalDiscount, 10) || 0;
            var savings = items.dataset.cartSavings;

            this.updateCartDiscounts(markup.discounts);
            this.updateSavings(savings);

            if (count > 0) {
            this.wrapper.classList.remove('is-empty');
            } else {
            this.wrapper.classList.add('is-empty');
            }

            setTimeout(() => {
              this.updateCount(count);
            }, 1500)

            // progressBar markup
            if(this.progressBar) {
                this.progressBar.innerHTML = progressBar.innerHTML;
            }
             // progressBarAlt markup
            if(this.progressBarAlt) {
                this.progressBarAlt.innerHTML = progressBarAlt.innerHTML;
            }

            if(this.gamification) {
              this.gamification.innerHTML = gamification.innerHTML;
            }

            if(this.gamificationAlt) {
              this.gamificationAlt.innerHTML = gamificationAlt.innerHTML;
            }

            // Append item markup
            this.products.innerHTML = '';
            this.products.append(items);

            // Build upsell markup
            if(cartEmptyUpsell) {
              this.cartEmptyUpsell.innerHTML = cartEmptyUpsell.innerHTML;
            }
            if(cartNonEmptyUpsell) {
              this.cartNonEmptyUpsell.innerHTML = cartNonEmptyUpsell.innerHTML;
            }

            // Update subtotal
            this.subtotal.innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);

            var originalWrap = this.form.querySelector(selectors.originalSubtotalWrap);
            var originalEl = this.form.querySelector(selectors.originalSubtotal);

            if (originalWrap && originalEl) {
              if (totalDiscount > 0) {
                originalWrap.classList.remove('hidden');
                originalEl.innerHTML = theme.Currency.formatMoney(originalSubtotal, theme.settings.moneyFormat);
              } else {
                originalWrap.classList.add('hidden');
              }
            }

            this.reInit();
            document.dispatchEvent(new CustomEvent('cart-upsell:init'));

            if(typeof yotpo) {
              var api = new Yotpo.API(yotpo);
              api.refreshWidgets();
            }

            if (window.AOS) { AOS.refreshHard() }

            if (Shopify && Shopify.StorefrontExpressButtons) {
              Shopify.StorefrontExpressButtons.initialize();
            }

            setTimeout(function(){
              //window.updateGamificationProgress();
            }, 500)
        },

        initDiscountForm: function() {
            if (!this.discountForm || this.discountForm.dataset.initialized === 'true') {
              return;
            }

            this.discountForm.dataset.initialized = 'true';

            var input = this.discountForm.querySelector(selectors.discountInput);
            var applyBtn = this.discountForm.querySelector(selectors.discountApply);

            if (!input || !applyBtn) {
              return;
            }

            applyBtn.addEventListener('click', this.handleDiscountApply.bind(this));

            input.addEventListener('keydown', function(evt) {
              if (evt.key === 'Enter') {
                evt.preventDefault();
                this.handleDiscountApply();
              }
            }.bind(this));

            var toggleBtn = this.discountForm.querySelector(selectors.discountToggle);
            var expandEl = this.discountForm.querySelector(selectors.discountExpand);

            if (toggleBtn && expandEl) {
              toggleBtn.addEventListener('click', function() {
                var isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
                var nextExpanded = !isExpanded;

                toggleBtn.setAttribute('aria-expanded', nextExpanded);
                this.discountForm.classList.toggle('is-expanded', nextExpanded);
                expandEl.hidden = !nextExpanded;

                if (nextExpanded) {
                  input.focus();
                } else {
                  this.clearDiscountMessage();
                }
              }.bind(this));
            }

            if (this.discounts) {
              this.discounts.addEventListener('click', function(evt) {
                var removeBtn = evt.target.closest('[data-discount-remove]');
                if (removeBtn) {
                  this.handleDiscountRemove(evt, removeBtn);
                }
              }.bind(this));
            }
        },

        handleDiscountApply: function() {
            if (!this.discountForm) {
              return;
            }

            var input = this.discountForm.querySelector(selectors.discountInput);
            var applyBtn = this.discountForm.querySelector(selectors.discountApply);
            var code = theme.cart.attributeToString(input.value);

            if (!code) {
              this.showDiscountMessage(this.discountForm.dataset.msgInvalid, 'error');
              input.focus();
              return;
            }

            applyBtn.disabled = true;
            applyBtn.classList.add(classes.btnLoading);
            this.clearDiscountMessage();

            var cartBefore = null;

            theme.cart.getCartJson()
              .then(function(cart) {
                cartBefore = cart;
                return theme.cart.applyDiscount(code);
              })
              .then(function(cartAfter) {
                // update.js returns the updated cart; fall back to a fresh cart.js if needed
                if (!cartAfter || typeof cartAfter.item_count === 'undefined') {
                  return theme.cart.getCartJson();
                }
                return cartAfter;
              })
              .then(function(cartAfter) {
                if (this.isDiscountCodeApplied(cartBefore, cartAfter, code)) {
                  input.value = '';
                  this.clearDiscountMessage();
                  this.trackAppliedDiscountCode(code);
                  document.dispatchEvent(new CustomEvent('cart:build'));
                  if (typeof handleGwp === 'function') {
                    handleGwp();
                  }
                } else {
                  this.showDiscountMessage(this.discountForm.dataset.msgInvalid, 'error');
                  input.focus();
                }
              }.bind(this))
              .catch(function() {
                this.showDiscountMessage(this.discountForm.dataset.msgInvalid, 'error');
                input.focus();
              }.bind(this))
              .finally(function() {
                applyBtn.disabled = false;
                applyBtn.classList.remove(classes.btnLoading);
              }.bind(this));
        },

        handleDiscountRemove: function(evt, removeBtn) {
            evt.preventDefault();

            removeBtn = removeBtn || evt.currentTarget;
            var codeToRemove = removeBtn.dataset.discountTitle;
            removeBtn.disabled = true;
            removeBtn.classList.add(classes.btnLoading);
            this.clearDiscountMessage();

            var trackedBefore = (this.appliedDiscountCodes || []).slice();
            var matchedTrackedCode = trackedBefore.some(function(code) {
              return code.toLowerCase() === (codeToRemove || '').toLowerCase();
            });

            this.untrackAppliedDiscountCode(codeToRemove);

            // Visible label may be a discount title, not the raw code
            if (!matchedTrackedCode) {
              this.appliedDiscountCodes = [];
            }

            var remainingCodes = (this.appliedDiscountCodes || []).join(',');
            var updatePromise = remainingCodes
              ? theme.cart.applyDiscount(remainingCodes)
              : theme.cart.removeDiscount();

            updatePromise
              .then(function() {
                document.dispatchEvent(new CustomEvent('cart:build'));
                if (typeof handleGwp === 'function') {
                  handleGwp();
                }
              })
              .catch(function() {
                if (matchedTrackedCode) {
                  this.trackAppliedDiscountCode(codeToRemove);
                } else {
                  this.appliedDiscountCodes = trackedBefore;
                }
                this.showDiscountMessage(this.discountForm.dataset.msgInvalid, 'error');
              }.bind(this))
              .finally(function() {
                removeBtn.disabled = false;
                removeBtn.classList.remove(classes.btnLoading);
              }.bind(this));
        },

        trackAppliedDiscountCode: function(code) {
            var normalized = theme.cart.attributeToString(code);
            if (!normalized) {
              return;
            }
            this.appliedDiscountCodes = this.appliedDiscountCodes || [];
            var exists = this.appliedDiscountCodes.some(function(existing) {
              return existing.toLowerCase() === normalized.toLowerCase();
            });
            if (!exists) {
              this.appliedDiscountCodes.push(normalized);
            }
        },

        untrackAppliedDiscountCode: function(code) {
            var normalized = (code || '').toLowerCase();
            this.appliedDiscountCodes = (this.appliedDiscountCodes || []).filter(function(existing) {
              return existing.toLowerCase() !== normalized;
            });
        },

        isDiscountCodeApplied: function(cartBefore, cartAfter, code) {
            if (!cartAfter) {
              return false;
            }

            var normalizedCode = (code || '').toLowerCase();
            cartBefore = cartBefore || {};

            // Discount titles in admin often differ from the code (e.g. "30% Off" vs "SCALP30")
            function discountMatchesCode(discount) {
              if (!discount) return false;
              var title = (discount.title || '').toLowerCase();
              var discountCode = (discount.code || '').toLowerCase();
              return title === normalizedCode
                || discountCode === normalizedCode
                || (title && title.indexOf(normalizedCode) !== -1)
                || (discountCode && discountCode.indexOf(normalizedCode) !== -1);
            }

            function collectApplications(cart) {
              var apps = (cart.cart_level_discount_applications || []).slice();
              (cart.items || []).forEach(function(item) {
                (item.discounts || []).forEach(function(discount) {
                  apps.push(discount);
                });
              });
              return apps;
            }

            var afterApps = collectApplications(cartAfter);
            if (afterApps.some(discountMatchesCode)) {
              return true;
            }

            // Monetary discount appeared or increased after apply
            if ((cartAfter.total_discount || 0) > (cartBefore.total_discount || 0)) {
              return true;
            }

            // New cart-level or line-level applications appeared
            if (afterApps.length > collectApplications(cartBefore).length) {
              return true;
            }

            // Line item discounted amounts increased
            var beforeItems = cartBefore.items || [];
            return (cartAfter.items || []).some(function(item) {
              var beforeItem = beforeItems.find(function(bi) {
                return bi.key === item.key;
              });
              var beforeDiscount = beforeItem ? (beforeItem.total_discount || 0) : 0;
              return (item.total_discount || 0) > beforeDiscount;
            });
        },

        updateCartDiscounts: function(markup) {
            if (!this.discounts) {
              return;
            }

            // Liquid often omits AJAX-applied discount codes from cart_level_discount_applications.
            // Prefer cart.js so applied codes (and remove buttons) stay visible after rebuild.
            this.refreshAppliedDiscountsFromCart();
        },

        refreshAppliedDiscountsFromCart: function() {
            if (!this.discounts) {
              return;
            }

            theme.cart.getCartJson()
              .then(function(cart) {
                this.renderAppliedDiscountsFromCart(cart);
              }.bind(this))
              .catch(function() {});
        },

        collectDiscountRows: function(cart) {
            var rows = [];
            var seen = {};

            function addRow(title, amount, removeKey) {
              var key = (removeKey || title || '').toLowerCase();
              if (!key || seen[key]) {
                return;
              }
              // Hide free-gift / free-shipping style discounts from the code list
              if (key.indexOf('free') !== -1) {
                return;
              }
              seen[key] = true;
              rows.push({
                title: title,
                amount: amount || 0,
                removeKey: removeKey || title
              });
            }

            (cart.cart_level_discount_applications || []).forEach(function(discount) {
              addRow(discount.title, discount.total_allocated_amount, discount.title);
            });

            (cart.items || []).forEach(function(item) {
              (item.discounts || []).forEach(function(discount) {
                addRow(discount.title, discount.amount || 0, discount.title);
              });
            });

            // Fallback when Liquid/cart apps don't list the manual code but we applied it
            if (rows.length === 0) {
              (this.appliedDiscountCodes || []).forEach(function(code) {
                addRow(code, cart.total_discount || 0, code);
              });
            }

            return rows;
        },

        renderAppliedDiscountsFromCart: function(cart) {
            if (!this.discounts) {
              return;
            }

            var rows = this.collectDiscountRows(cart);
            var removeLabel = this.discountForm
              ? this.discountForm.dataset.msgRemove
              : 'Remove discount code';
            var discountsLabel = this.discountForm
              ? this.discountForm.dataset.labelDiscounts
              : 'Discounts';
            var removeIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M25.8994 6.10059L6.10042 25.8996" stroke="#383F2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/><path d="M25.8996 25.8996L6.10059 6.10059" stroke="#383F2D" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"/></svg>';

            this.discounts.innerHTML = '';

            if (!rows.length) {
              return;
            }

            var wrapper = document.createElement('div');
            wrapper.className = 'cart__discounts cart__item-sub cart__item-row';

            var label = document.createElement('div');
            label.textContent = discountsLabel;

            var values = document.createElement('div');
            values.className = 'text-right';

            rows.forEach(function(row) {
              var item = document.createElement('div');
              item.className = 'cart__discount cart__discount-description cart__discount-applied-item';

              var text = document.createElement('span');
              var amountHtml = row.amount > 0
                ? ' (-' + theme.Currency.formatMoney(row.amount, theme.settings.moneyFormat).replace(/<[^>]*>/g, '') + ')'
                : '';
              text.textContent = row.title + amountHtml;

              var removeBtn = document.createElement('button');
              removeBtn.type = 'button';
              removeBtn.className = 'cart__discount-remove text-link';
              removeBtn.dataset.discountRemove = '';
              removeBtn.dataset.discountTitle = row.removeKey;
              removeBtn.setAttribute('aria-label', removeLabel + ': ' + row.title);
              removeBtn.innerHTML = removeIcon;

              item.appendChild(text);
              item.appendChild(removeBtn);
              values.appendChild(item);
            });

            wrapper.appendChild(label);
            wrapper.appendChild(values);
            this.discounts.appendChild(wrapper);
        },

        showDiscountMessage: function(message, type) {
            if (!this.discountForm) {
              return;
            }

            var messageEl = this.discountForm.querySelector(selectors.discountMessage);
            if (!messageEl) {
              return;
            }

            messageEl.textContent = message;
            messageEl.hidden = false;
            messageEl.classList.remove('cart__drawer-discount-message--error', 'cart__drawer-discount-message--success');
            messageEl.classList.add(type === 'success' ? 'cart__drawer-discount-message--success' : 'cart__drawer-discount-message--error');
        },

        clearDiscountMessage: function() {
            if (!this.discountForm) {
              return;
            }

            var messageEl = this.discountForm.querySelector(selectors.discountMessage);
            if (!messageEl) {
              return;
            }

            messageEl.textContent = '';
            messageEl.hidden = true;
            messageEl.classList.remove('cart__drawer-discount-message--error', 'cart__drawer-discount-message--success');
        },

        /*============================================================================
            Quantity handling
        ==============================================================================*/
        initQtySelectors: function() {
            this.form.querySelectorAll(selectors.qtySelector).forEach(el => {
            var selector = new theme.QtySelector(el, {
                namespace: this.namespace,
                isCart: true
            });
            });
        },

        /*============================================================================
            Cart remove handling
        ==============================================================================*/
        initRemoveSelectors: function() {
            this.form.querySelectorAll(selectors.removeSelector).forEach(el => {
            new theme.RemoveSelector(el);
            });
        },

        /*============================================================================
            Cart purchase handling
        ==============================================================================*/
        initUpdatePurchase: function() {
            if(this.form.querySelectorAll(selectors.upgradeBtn)) {
            this.form.querySelectorAll(selectors.upgradeBtn).forEach(el => {
                new theme.UpdatePurchase(el);
            });
            }
        },

        initPurchaseSelectors: function() {
            if(this.form.querySelectorAll(selectors.purchaseSelect)) {
            this.form.querySelectorAll(selectors.purchaseSelect).forEach(el => {
                new theme.PurchaseSelector(el);
            });
            }
        },

        quantityChanged: function(evt) {
            var key = evt.detail[0];
            var qty = evt.detail[1];
            var el = evt.detail[2];

            if (!key || !qty) {
            return;
            }

            // Disable qty selector so multiple clicks can't happen while loading
            if (el) {
            el.classList.add('is-loading');
            }

            theme.cart.changeItem(key, qty)
            .then(function(cart) {

                const parsedCart = JSON.parse(cart);

                if (parsedCart.status === 422) {
                alert(parsedCart.message);
                } else {
                const updatedItem = parsedCart.items.find(item => item.key === key);

                // Update cartItemsUpdated property on object so we can reference later
                if (updatedItem && (evt.type === 'cart:quantity.cart-cart-drawer' || evt.type === 'cart:quantity.cart-header')) {
                    this.cartItemsUpdated = true;
                }

                if ((updatedItem && evt.type === 'cart:quantity.cart-cart-drawer') || (updatedItem && evt.type === 'cart:quantity.cart-header')) {
                    if (updatedItem.quantity !== qty) {
                    }
                    // Reset property on object so that checkout button will work as usual
                    this.cartItemsUpdated = false;
                }

                if (parsedCart.item_count > 0) {
                    this.wrapper.classList.remove('is-empty');
                } else {
                    this.wrapper.classList.add('is-empty');
                }
                }

                this.buildCart();

                document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: {
                    cart: parsedCart
                }
                }));
            }.bind(this))
            .catch(function(XMLHttpRequest){});
        },

        /*============================================================================
            Update elements of the cart
        ==============================================================================*/
        updateSubtotal: function(subtotal) {
            this.form.querySelector(selectors.subTotal).innerHTML = theme.Currency.formatMoney(subtotal, theme.settings.moneyFormat);
        },

        updateSavings: function(savings) {
            if (!this.savings) {
            return;
            }

            if (savings > 0) {
            var amount = theme.Currency.formatMoney(savings, theme.settings.moneyFormat);
            this.savings.classList.remove('hide');
            this.savings.innerHTML = theme.strings.cartSavings.replace('[savings]', amount);
            } else {
            this.savings.classList.add('hide');
            }
        },

        updateCount: function(count) {
          setTimeout(() => {
            window.updateRTEBasedOnCondition();
          }, 200)

            var countEls = document.querySelectorAll('.cart-link__bubble-num');

            if (countEls.length) {
            countEls.forEach(el => {
                el.innerText = count;
            });
            }

            // show/hide bubble(s)
            var bubbles = document.querySelectorAll(selectors.cartBubble);
            if (bubbles.length) {
            if (count > 0) {
                bubbles.forEach(b => {
                b.classList.add('cart-link__bubble--visible');
                });
            } else {
                bubbles.forEach(b => {
                b.classList.remove('cart-link__bubble--visible');
                });
            }
            }
        }
        });

        return CartForm;
    })();

    theme.QtySelector = (function() {
        var selectors = {
        input: '.js-qty__num',
        plus: '.js-qty__adjust--plus',
        minus: '.js-qty__adjust--minus'
        };

      function QtySelector(el, options) {
        this.wrapper = el;
        this.plus = el.querySelector(selectors.plus);
        this.minus = el.querySelector(selectors.minus);
        this.input = el.querySelector(selectors.input);
        this.minValue = this.input.getAttribute('min') || 1;

        var defaults = {
            namespace: null,
            isCart: false,
            key: this.input.dataset.id
        };

        this.options = Object.assign({}, defaults, options);

        this.init();
        }

        QtySelector.prototype = Object.assign({}, QtySelector.prototype, {
        init: function() {
            this.plus.addEventListener('click', function() {
            var qty = this._getQty();
            this._change(qty + 1);
            }.bind(this));

            this.minus.addEventListener('click', function() {
            var qty = this._getQty();
            this._change(qty - 1);
            }.bind(this));

            this.input.addEventListener('change', function(evt) {
            this._change(this._getQty());
            }.bind(this));
        },

        _getQty: function() {
            var qty = this.input.value;
            if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
            // We have a valid number!
            } else {
            // Not a number. Default to 1.
            qty = 1;
            }
            return parseInt(qty);
        },

        _change: async function(qty) {
          if (qty <= this.minValue) {
            qty = this.minValue;
          }

          this.input.value = qty;

          if(qty == 0) {
            const cartItem = this.wrapper.closest('.cart__item');
            if(cartItem.hasAttribute('data-free-pair-id')) {
              await fetch("/cart/change.js", {
                method: 'POST',
                body: JSON.stringify({
                  "id": cartItem.getAttribute('data-free-pair-id'),
                  "quantity": 0
                }),
                dataType: 'json',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' }
              });
            }
          }

          if (this.options.isCart) {
            document.dispatchEvent(new CustomEvent('cart:quantity' + this.options.namespace, {
              detail: [this.options.key, qty, this.wrapper]
            }));
            document.dispatchEvent(new CustomEvent('cart:build'));
          }
        }
      });

      return QtySelector;
    })();

    theme.RemoveSelector = (function() {
        function cartRemoveSelector(el) {
          this.removeBtn = el;
          this.checkoutButton = document.querySelector('.btn.cart__checkout');
          this.init();
        }

        cartRemoveSelector.prototype = Object.assign({}, cartRemoveSelector.prototype, {
          init: function() {
            this.removeBtn.addEventListener('click', async function(e) {
              e.preventDefault();

              const url = this.removeBtn.getAttribute("href");
              this.removeBtn.classList.add("btn--loading");
              if (this.checkoutButton) {
                this.checkoutButton.disabled = true;
              }

              // Collapse the item visually after brief icon animation
              const cartItem = this.removeBtn.closest('.cart__item');
              if (cartItem) {
                setTimeout(() => {
                  cartItem.style.transition = 'opacity 0.3s ease, max-height 0.3s ease';
                  cartItem.style.overflow = 'hidden';
                  cartItem.style.maxHeight = cartItem.offsetHeight + 'px';
                  requestAnimationFrame(() => {
                    cartItem.style.opacity = '0';
                    cartItem.style.maxHeight = '0';
                  });
                }, 500);
              }

              try {
                // Fire remove fetch and cart rebuild in parallel
                await fetch(url, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                  }
                })

                if(cartItem && cartItem.hasAttribute('data-free-pair-id')) {
                  await fetch("/cart/change.js", {
                    method: 'POST',
                    body: JSON.stringify({
                      "id": cartItem.getAttribute('data-free-pair-id'),
                      "quantity": 0
                    }),
                    dataType: 'json',
                    credentials: 'same-origin',
                    headers: { 'Content-Type': 'application/json' }
                  });
                }
                document.dispatchEvent(new CustomEvent('cart:build'));
                handleGwp();
                theme.cart.Cart();
              } finally {
                const btn = document.querySelector('.btn.cart__checkout');
                if (btn) {
                  btn.disabled = false;
                }
              }

            }.bind(this));
          },


          _updateCart: function(url) {
            fetch(url, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              }
            })
            .then(response => {
              response.json;
            })
            .then(data => {
              this.removeBtn.classList.remove("btn--loading");
              document.dispatchEvent(new CustomEvent('cart:build'));
              handleGwp();
              theme.cart.Cart();
            })
          }
        });

        return cartRemoveSelector;
    })();

      theme.UpdatePurchase = (function() {
        function cartUpdatePurchase(el) {
          this.upgradeBtn = el;
          this.init();
        }

        cartUpdatePurchase.prototype = Object.assign({}, cartUpdatePurchase.prototype, {
          init: function() {
            this.upgradeBtn.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              this.upgradeBtn.innerText = "Upgrading...";
              this.upgradeBtn.setAttribute("disabled", "disabled");
              const sellingId = this.upgradeBtn.dataset.firstSelectedSellingPlanId;
              const lineItemIndex = this.upgradeBtn.dataset.lineItemIndex;
              const qty = parseInt(this.upgradeBtn.dataset.lineItemQuantity);
              const variantId = this.upgradeBtn.dataset.selectedVariantId;

              this._updateCart(lineItemIndex, qty, sellingId, variantId);
              return false;
            }.bind(this));
          },

          _updateCart: async function(lineItemIndex, qty, sellingId, variantId) {
            const data = {
              line: lineItemIndex,
              quantity: variantId? 0 : qty,
            }
            if(!variantId) {
              data.selling_plan = sellingId;
            }

            await fetch("/cart/change.js", {
              method: 'POST',
              body: JSON.stringify(data),
              dataType: 'json',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json'
              }
            })

            if(variantId) {
              await fetch("/cart/add.js", {
                method: 'POST',
                body: JSON.stringify({
                  id: variantId,
                  quantity: qty,
                  selling_plan: sellingId
                }),
                dataType: 'json',
                credentials: 'same-origin',
                headers: {
                  'Content-Type': 'application/json'
                }
              });
            }

            document.dispatchEvent(new CustomEvent('cart:build'));
          }
        });

        return cartUpdatePurchase;
    })();

      theme.PurchaseSelector = (function() {
        function cartPurchaseSelector(el) {
          this.purchaseSelector = el;
          this.init();
        }

        cartPurchaseSelector.prototype = Object.assign({}, cartPurchaseSelector.prototype, {
         init: function() {
            this.purchaseSelector.addEventListener('change', async function(e) {
              e.preventDefault();

              const sellingId = parseInt(e.target.value);
              const lineItemIndex = this.purchaseSelector.dataset.lineItemIndex;
              const qty = parseInt(this.purchaseSelector.dataset.lineItemQuantity);
              const variantId = this.purchaseSelector.options[this.purchaseSelector.selectedIndex].dataset.variantId;

              // For OTP on variant-specific products, fall back to first option with data-variant-id
              // since the OTP option itself has no data-variant-id
              let resolvedVariantId = variantId;
              if (!resolvedVariantId && isNaN(sellingId)) {
                const fallbackOption = this.purchaseSelector.querySelector('option[data-variant-id]');
                resolvedVariantId = fallbackOption ? fallbackOption.dataset.variantId : null;
              }

              await this._updateCart(lineItemIndex, qty, sellingId, resolvedVariantId);

              if(e.target.closest('.cart__item').hasAttribute('data-free-pair-id')) {
                await fetch("/cart/change.js", {
                  method: 'POST',
                  body: JSON.stringify({
                    "id": e.target.closest('.cart__item').getAttribute('data-free-pair-id'),
                    "quantity": 0
                  }),
                  dataType: 'json',
                  credentials: 'same-origin',
                  headers: { 'Content-Type': 'application/json' }
                });
                document.dispatchEvent(new CustomEvent('cart:build'));
              }

            }.bind(this));
          },

         _updateCart: async function(lineItemIndex, qty, sellingId, variantId) {
            const data = {
              line: lineItemIndex,
              quantity: variantId ? 0 : qty
            }

            // Only set selling_plan for non-OTP. For OTP, omitting selling_plan
            // tells Shopify to treat it as a one-time purchase.
            // For simple products (no variantId), sending selling_plan: NaN also works
            // as Shopify ignores invalid values and removes the plan.
            if (!variantId) {
                // For subscription: set the selected selling_plan ID.
                // For OTP: explicitly send empty string to remove the existing selling plan.
                // Shopify requires an explicit value to clear a plan — omitting it has no effect.
                data.selling_plan = !isNaN(sellingId) ? sellingId : '';
              }

            this.purchaseSelector.setAttribute("disabled", "disabled");

            await fetch("/cart/change.js", {
              method: 'POST',
              body: JSON.stringify(data),
              dataType: 'json',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' }
            });

            if (variantId) {
              // Re-add with or without selling plan.
              // For OTP: no selling_plan so Shopify treats it as one-time purchase.
              // For subscription: include the selected selling_plan ID.
              const addData = { id: variantId, quantity: qty };
              if (!isNaN(sellingId)) {
                addData.selling_plan = sellingId;
              }

              await fetch("/cart/add.js", {
                method: 'POST',
                body: JSON.stringify(addData),
                dataType: 'json',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json' }
              });
            }

            document.dispatchEvent(new CustomEvent('cart:build'));
          }
        });

        return cartPurchaseSelector;
    })();

    if (!document.body.classList.contains('template-cart')) {
        new theme.CartDrawer();
    };

    function initUpsellSlider() {
        new Swiper("[js-upsell-slider]", {
            loop: true,
            pagination: {
              el: '.swiper-pagination',
              clickable: true
            },
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            // grabCursor: false,
            slidesPerView: 1.05,
            // draggable:!0,
            autoHeight:!1,
            // watchOverflow:!0,
            threshold:10,
            // mousewheel:{
              // forceToAxis:!0
            // },
            // freeMode: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                0: {
                    spaceBetween: 10
                },
                768: {
                    spaceBetween: 10
                }
            }
        });
    };

    initUpsellSlider();
    initUpsellBtn();

    document.addEventListener("cart-upsell:init", function() {
        initUpsellSlider();
        initUpsellBtn();
    });

    function initUpsellBtn() {
        const upsellBtn = document.querySelectorAll("[js-upsell-btn]");

        upsellBtn.forEach( btn => {
            btn.addEventListener('click', upsellAddToCart)
        });

        function upsellAddToCart() {
            const productId = this.dataset.productId;
            const sellingId = this.dataset.sellingPlanId;

            this.classList.add("btn--loading");

            const data = {
                items: [
                    {
                        id: productId,
                        quantity: 1,
                        selling_plan: sellingId
                    }
                ]
            }

            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            })
            .then((response) => response.json())
            .then((data) => {
              this.classList.remove("btn--loading");
              document.dispatchEvent(new CustomEvent('cart:build'));
              document.dispatchEvent(new CustomEvent('cart:open'));

              handleGwp();
            })
        }
    }

  cartDiscountFormObserver();
  function cartDiscountFormObserver () {

    const targetNode = document.querySelector("#CartDrawer");
    const config = { attributes: true, childList: true, subtree: true };

    const callback = (mutationList, observer) => {
      let is_changed = false;
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          if(mutation.target.classList.contains('scDiscount__container') || mutation.target.querySelector('.scDiscount__container')) {
            is_changed = true;
          }
        } else if (mutation.type === "attributes") {
          if(mutation.target.classList.contains('scDiscount__container') || mutation.target.querySelector('.scDiscount__container')) {
            is_changed = true;
          }
        }
      }
      if(is_changed) {
        cartDFromCntObserver();
      }
    };

    const c_observer = new MutationObserver(callback);
    c_observer.observe(targetNode, config);
  }

  let dFormCntObserver = null;
  function cartDFromCntObserver() {
    if(dFormCntObserver != null) {
      return;
    }
    const targetNode = document.querySelector("#CartDrawer .scDiscount__container");
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          if(mutation.removedNodes.length == 0) {
            handleGwp();
          }
        } else if (mutation.type === "attributes") {
        }
      }
    };
    dFormCntObserver = new MutationObserver(callback);
    dFormCntObserver.observe(targetNode, config);
  }

})();

class SubscriptionSelect extends HTMLElement {
  constructor() {
    super();
    this.select = null;
  }

  connectedCallback() {
    this.select = this.querySelector("select");
    if (!this.select) return;

    // Initial sizing
    this.updateWidth();

    // Update on change
    this.select.addEventListener("change", () => {
      this.updateWidth();
    });
  }

  updateWidth() {
    const selectedOption = this.select.options[this.select.selectedIndex];
    if (!selectedOption) return;

    const text = selectedOption.text;

    // Create temporary element to measure text width
    const temp = document.createElement("span");
    temp.style.visibility = "hidden";
    temp.style.whiteSpace = "nowrap";
    temp.style.position = "absolute";
    temp.style.font = getComputedStyle(this.select).font;
    temp.textContent = text;

    document.body.appendChild(temp);

    const width = temp.offsetWidth;

    document.body.removeChild(temp);

    // Add some padding for dropdown arrow
    const extra = 35;

    this.select.style.width = `${width + extra}px`;
  }
}

customElements.define("subscription-select", SubscriptionSelect);